import { default as api } from 'config/authApiConf.js';

export const listPortfolioService = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-portfolio?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
